import React from 'react';
import Button from '../../components/Button/Button';
import { TierPlan } from './PaymentManager'; // Assuming TierPlan is exported from PaymentManager or a shared types file

interface PlanCardProps {
  tierPlan: TierPlan;
  billingInterval: 'month' | 'year';
  onPurchase: (priceId?: string, productId?: string) => void;
  isCreatingCheckout: string | null;
  isFree?: boolean;

}

const PlanCard: React.FC<PlanCardProps> = ({ 
  tierPlan, 
  billingInterval, 
  onPurchase,
  isCreatingCheckout,
  isFree = false,

}) => {
  // Determine price, priceId, productId based on selected interval
  const displayPrice = billingInterval === 'month' 
    ? tierPlan.monthlyDisplayPrice 
    : tierPlan.yearlyDisplayPrice;
  const priceId = billingInterval === 'month' 
    ? tierPlan.monthlyPriceId 
    : tierPlan.yearlyPriceId;
  const productId = billingInterval === 'month' 
    ? tierPlan.monthlyProductId 
    : tierPlan.yearlyProductId;
      
  // If no display price exists for this interval, skip rendering this tier card
  if (!displayPrice) {
    return null;
  }
    
  let yearlySavingsAmount: number | null = null;
  // Ensure amounts are numbers before calculating
  const monthlyAmountNum = typeof tierPlan.monthlyAmount === 'number' ? tierPlan.monthlyAmount : null;
  const yearlyAmountNum = typeof tierPlan.yearlyAmount === 'number' ? tierPlan.yearlyAmount : null;

  // Calculate savings only for team/enterprise if amounts are valid
  if (billingInterval === 'year' && (tierPlan.tierName.toLowerCase() === 'team' || tierPlan.tierName.toLowerCase() === 'enterprise') && monthlyAmountNum !== null && yearlyAmountNum !== null) {
      const monthlyCostAnnualized = monthlyAmountNum * 12;
      if (monthlyCostAnnualized > yearlyAmountNum) {
          yearlySavingsAmount = monthlyCostAnnualized - yearlyAmountNum;
      }
  }

  return (
    // Use tierName for key and class
    <div className={`plan-card plan-card-${tierPlan.tierName.toLowerCase() || 'unknown'}`}>
      <div className={`plan-card-content ${isFree ? 'plan-card-content--no-aspect' : ''}`}>
        <div className="payment-name">{tierPlan.tierName}</div>
        {tierPlan.description && (
          <div className="payment-description">{tierPlan.description}</div>
        )}
        <div className="price-action-container">
          <div className="payment-price-container"> 
            <div className="payment-price">{displayPrice}</div>
            
            {billingInterval === 'year' && yearlySavingsAmount && yearlySavingsAmount > 0 && (
              <div className="plan-savings-indicator">
                Save ${ (yearlySavingsAmount / 100).toFixed(2) } / year
              </div>
            )}
          </div>
          <div className="payment-action">
            <Button
              variant="primary"
              size="large"
              onClick={() => onPurchase(priceId, productId)} // Pass correct productId
              isLoading={isCreatingCheckout === priceId}
              // Disable if priceId or productId is missing OR another checkout is loading
              disabled={!priceId || !productId || !!isCreatingCheckout}
            >
              Select Plan
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlanCard; 